{
	"forms": {
		"minimum_value_is": "Minimiarvo on {{val}}",
		"maximum_value_is": "Maksimiarvo on {{val}}"
	},
	"general": {
		"login": "Kirjaudu sisään",
		"email": "Sähköposti",
		"password": "Salasana",
		"error_connecting_to_server": "Palvelimeen ei saada yhteyttä",
		"required": "Vaaditaan",
		"logging_in": "Kirjaudutaan sisään...",
		"something_went_wrong": "Jotain meni pieleen",
		"forgot_your_password": "Unohditko salasanasi?",
		"register": "Rekisteröidy",
		"send_message": "Lähetä viesti",
		"message_history": "Viestihistoria",
		"contacts": "Yhteystiedot",
		"credits": "Krediitit",
		"account": "Tili",
		"customer_service": "Asiakaspalvelu",
		"log_out": "Kirjaudu ulos",
		"really_log_out": "Haluatko varmasti kirjautua ulos?",
		"cancel": "Peru",
		"loading": "Ladataan...",
		"home": "Aloitus",
		"welcome_use_tavoittaja": "Tervetuloa käyttämään Tavoittajaa!",
		"credits_to_use": "krediittiä",
		"buy_credits": "Osta krediittejä",
		"send_message_guide": "Voit lähettää tekstiviestejä tallentamillesi ryhmille tai määrittää vastaanottajat käsin. Voit myös ajastaa viestin lähetettäväksi myöhempänä ajankohtana. Varmistathan ennen viestin luontia, että tililläsi on krediittejä viestin lähettämiseen. ",
		"did_you_know": "Tiesitkö että...",
		"continue_to_confirm": "Siirry valitsemaan lähetysaika",
		"sender": "Lähettäjä",
		"message": "Viesti",
		"credits_per_message": "krediittiä per viesti",
		"characters": "merkkiä",
		"receivers": "Vastaanottajat",
		"groups": "Ryhmät",
		"subject": "Aihe",
		"send_message_to_customer_service": "Lähetä viesti asiakaspalveluun",
		"customer_service_info_text": "Voit ottaa yhteyttä asiakaspalveluumme alla olevalla lomakkeella.",
		"phone_number_short": "Puh.",
		"support_open_times": "(ma - pe 09.00-17.00)",
		"service_is_owned_by": "Palvelun omistaa",
		"thanks_for_message": "Kiitos viestistäsi!",
		"we_will_contact_asap": "Otamme teihin yhteyttä mahdollisimman pian.",
		"account_guide": "Muista pitää tilin tiedot ajan tasalla.",
		"personal_information": "Omat tiedot",
		"change_password": "Vaihda salasana",
		"inbound_numbers": "Lähetysnumerot",
		"api": "API",
		"users": "Käyttäjät",
		"first_name": "Etunimi",
		"last_name": "Sukunimi",
		"phone": "Puhelinnumero",
		"save": "Tallenna",
		"account_information": "Tilin tiedot",
		"name": "Nimi",
		"businessID": "Y-tunnus",
		"city": "Kaupunki",
		"postal_code": "Postinumero",
		"postal_address": "Osoite",
		"saved": "Tallennettu",
		"please_wait": "Odota...",
		"oops_something_went_wrong": "Hups, jotain meni pieleen",
		"unexpected_error": "Tapahtui odottamaton virhe.",
		"we_are_informed": "Olemme tietoisia ongelmasta, ja korjaamme sen niin pian kuin mahdollista.",
		"reload_page": "Lataa sivu uudelleen",
		"new_password": "Uusi salasana",
		"new_password_again": "Uusi salasana uudestaan",
		"change_your_accounts_password": "Vaihda tilisi salasana",
		"password_guide": "Kun luot uutta salasanaa, varmista, että se on vähintään 6 merkkiä pitkä. Yritä käyttää numeroiden, kirjaimien ja välimerkkien yhdistelmiä.",
		"passwords_do_not_match": "Salasanat eivät täsmää",
		"select_credit_amount": "Valitse krediittipaketin koko",
		"select_amount_manually": "Tai syötä vapaavalintainen määrä",
		"amount_short": "kpl",
		"select_payment_method": "Valitse maksutapa",
		"online_payment": "Verkkomaksu (Paytrail)",
		"payment_details": "Ostoksen tiedot",
		"price_without_vat": "Veroton hinta",
		"vat": "ALV 25.5%",
		"payment_fee": "Laskutuslisä",
		"total": "Yhteensä",
		"use_discount_code": "Käytä alennuskoodi",
		"continue_to_pay": "Siirry maksamaan",
		"buy_atleast_500_credits": "Minimiostos on 500 krediittiä.",
		"enter_code": "Syötä alennuskoodi",
		"apply": "Lisää",
		"discount_applied": "Alennuskoodi hyväksytty",
		"buy_credits_guide": "Tarvitset tekstiviestin lähettämiseen krediittejä. Yksi tekstiviestikrediitti vastaa yhtä normaalimittaista tekstiviestiä. Voit maksaa ostoksen verkkomaksulla tai laskulla. Krediitit ovat voimassa 365 päivää viimeisimmästä ostosta, ja minimiostos on 500 kappaletta.",
		"credit_buy_history": "Ostohistoria",
		"history_guide": "Alla näet listan aiemmista ostoksistasi.",
		"select_account": "Valitse tili, jolla haluat kirjautua sisään",
		"password_must_be_at_least_8_characters": "Salasanan täytyy olla ainakin 8 merkkiä pitkä.",
		"account_has_credits": "Tililläsi on tällä hetkellä {{credits}} krediittiä.",
		"admin": "Admin",
		"oops_not_found": "Hups! Sivua ei löytynyt.",
		"this_page_does_not_exist": "Näyttää siltä, että eksyit polulta – ohjataan sinut takaisin oikealle reitille.",
		"go_to_homepage": "Siirry etusivulle",
		"phone_in_international_format": "Puhelinnumero kansainvälisessä muodossa (+358 123 456 789)",
		"recover_password": "Palauta salasana",
		"recover_password_guide": "Anna tiliisi yhdistetty sähköpostiosoite, niin lähetämme sähköpostin, jossa on linkki salasanan vaihtoon.",
		"go_back": "Takaisin",
		"send_recovery_email": "Lähetä palautuslinkki",
		"check_your_email": "Tarkista sähköpostisi",
		"we_have_sent_recovery_details": "Jos järjestelmästämme löytyy käyttäjä antamallasi sähköpostiosoitteella, olemme lähettäneet salasanan palautusohjeet sähköpostiisi.",
		"back_to_login": "Takaisin",
		"set_a_password": "Aseta uusi salasana",
		"invalid_token": "Virheellinen tai vanhentunut linkki. Varmista että kopiot koko linkin.",
		"password_recovery_done": "Salasana vaihdettu. Voit nyt kirjautua sisään.",
		"register_guide_1": "Palvelun käyttöönotto on nopeaa ja ilmaista.",
		"credit_offer": "100 krediitin tutustumistarjous koskee vain uusia yritys- sekä yhdistysasiakkaita. Saat krediitit, kun tilisi on vahvistettu.",
		"you_must_represent_organization": "Huom, sinulla tulee olla oikeus edustaa organisaatiota, jonka nimissä tili avataan.",
		"password_again": "Salasana uudestaan",
		"organization": "Yritys/yhdistys",
		"really_go_back": "Rekisteröityminen on kesken. Halautko varmasti palata takaisin kirjautumiseen?",
		"have_read_terms": "Olen lukenut ja hyväksynyt palvelun ",
		"service_is_meant_for": "Palvelun käyttö on tarkoitettu yritysten ja yhteisöjen viestintään ja markkinointiin. Palvelua ei ole tarkoitettu yksityishenkilöiden väliseen yhteydenpitoon.",
		"terms_and_conditions": "käyttöehdot",
		"no_account_yet": "Ei vielä käyttäjää? ",
		"register_done": "Loimme sinulle tilin, ja lähetimme sähköpostiisi linkin, jonka kautta pääset täyttämään loput tiedot. Voit nyt sulkea tämän välilehden.",
		"register_successful": "Rekisteröinti onnistui",
		"create_user": "Luo käyttäjä",
		"create_user_successful": "Käyttäjä luotu",
		"you_can_now_login": "Voit nyt kirjautua sisään.",
		"inbound_numbers_guide": "Mahdollista 2-suuntainen viestinvälitys varaamalla oma lähetysnumerosi. Lähettäessäsi viestin varaamastasi lähetynumerosta viestin vastaanottaja voi vastata viestiin. ",
		"contact_customer_service_to_order_inbound_number": "Lähetysnumeron hinta on 49€/kk 0% ALV.",
		"api_guide": "Voit integroida tekstiviestien lähettämisen myös omiin järjestelmiisi käyttämällä Tavoittajan APIa. ",
		"contact_email": "Yhteyshenkilön sähköposti",
		"contact_email_guide": "Mikäli teemme muutoksia APIin, ilmoitamme niistä tähän sähköpostiosoitteeseen.",
		"guide": "Ohjeet",
		"company": "Yritys",
		"sort_asc": "Järjestä nousevasti",
		"sort_desc": "Järjestä laskevasti",
		"choose_visible_columns": "Valitse näytettävät kentät",
		"search": "Hae",
		"clear": "Tyhjennä",
		"paytrail_payment_terms": "Paytrail maksupalveluehdot",
		"no_data": "Ei dataa",
		"time_created": "Luotu",
		"vat_code": "ALV-tunnus",
		"billing_email": "Sähköposti johon tilausvahvistukset ja kuitit lähetetään",
		"billing_email_with_invoicing": "Sähköposti johon tilausvahvistukset, kuitit ja mahdolliset laskut lähetetään",
		"order": "Tilaus",
		"order_id": "Tilausnumero",
		"product_info": "Tuotetiedot",
		"total_without_vat": "Veroton hinta",
		"payment_method": "Maksutapa",
		"invoice": "Lasku",
		"receiver": "Saaja",
		"payer": "Maksaja",
		"buy_date": "Ostopäivämäärä",
		"product": "Tuote",
		"open_receipt": "Avaa kuitti",
		"price_does_not_include_vat": "(Hinta ei sis. ALV 25.5%)",
		"regular": "Tavallinen käyttäjä",
		"role": "Rooli",
		"users_guide": "Selaa, lisää, muokkaa ja poista käyttäjiä ja heidän tietojaan.",
		"edit": "Muokkaa",
		"is_admin": "Admin",
		"cannot_edit_your_own_role": "Et voi muuttaa omaa rooliasi.",
		"you_can_only_edit_other_users_role": "Voit muokata ainoastaan muiden käyttäjen roolia.",
		"remove_from_account": "Poista",
		"remove": "Poista",
		"remove_user": "Poista käyttäjä",
		"really_remove_user": "Poistetaanko käyttäjä tältä tililtä?",
		"add_user": "Lisää käyttäjä",
		"job_title": "Ammattinimike",
		"import_from_file": "Tuo tiedostosta",
		"custom_fields": "Lisätietokentät",
		"message_templates": "Viestipohjat",
		"schedule_send": "Ajasta lähetys",
		"manual_receivers_guide": "Syötä jokainen numero omalle rivilleen tai erota ne pilkulla.",
		"click_to_set_date_and_time": "Klikkaa asettaaksesi päivä ja aika",
		"message_templates_guide": "Voit tallettaa valmiita tekstiviestipohjia nopeuttaaksesi viestien lähetystä.",
		"contacts_amount": "aktiivista yhteystietoa",
		"contact_amount": "aktiivinen yhteystieto",
		"groups.with_0_contacts_are_not_shown": "Ryhmiä joissa ei ole aktiivisia yhteystietoja ei voi valita.",
		"send_now": "Lähetä heti",
		"send": "Lähetä",
		"character_count": "Merkkimäärä",
		"drafts": "Luonnokset",
		"drafts_guide": "Selaa luonnoksia tällä sivulla.",
		"message_must_have_at_least_one_recipient": "Viestillä täytyy olla ainakin yksi vastaanottaja",
		"confirm_details": "Vahvista lähetyksen tiedot",
		"confirm_details_guide": "Tarkista vielä huolellisesti viestin tiedot ennen lähetyksen hyväksymistä. ",
		"back": "Takaisin",
		"selected": "valittu",
		"remove_message": "Poista luonnos",
		"really_remove_message": "Poistetaanko tämä luonnos?",
		"deleted": "Poistettu",
		"none_selected": "Ei valittuja rivejä",
		"selected_rows": "Muokkaa valittuja",
		"delete_selected": "Poista valitut",
		"delete": "Poista",
		"remove_messages": "Poista valitut luonnokset",
		"really_remove_messages": "Haluatko varmasti poistaa valitut luonnokset?",
		"remove_users": "Poista valitut käyttäjät",
		"really_remove_users": "Haluatko varmasti poistaa valitut käyttäjät?",
		"receiver_groups": "Vastaanottajaryhmiä",
		"receiver_manual_contacts": "Käsin syötettyjä vastaanottajia",
		"sent_messages_guide": "Täältä voit tarkastella lähetettyjen viestiesi tietoja. Saat tarkan lähetysraportin esille klikkaamalla viestiä. Viestien vastaanottajien tietoja säilytetään kuluvan ja edellisen kalenterivuoden osalta.",
		"sent_messages": "Viestihistoria",
		"status_draft": "Luonnos",
		"status_scheduled": "Ajastettu",
		"status_waiting_to_be_sent": "Odottaa lähetystä",
		"status_ongoing": "Lähetys käynnissä",
		"status_completed": "Valmis",
		"status_error": "Virhe",
		"status_unknown": "Tuntematon",
		"successful_sends": "Toimitettu",
		"waiting_to_be_sent_count": "Odottaa lähetystä",
		"status": "Tila",
		"time_sent": "Lähetysaika",
		"single_message_history": "Lähetyksen tiedot",
		"single_message_history_guide": "Alla näet yksityiskohtaisen raportin lähetyksen tiedoista. ",
		"is_scheduled": "Ajastettu",
		"no": "Ei",
		"yes": "Kyllä",
		"true": "Kyllä",
		"error_details": "Virheen tiedot",
		"errors": "Virhettä",
		"details_do_not_update_in_real_time": "Lähetyksen tiedot eivät päivity reaaliajassa. Päivitä sivu nähdäksesti ajantasaiset tiedot.",
		"not_sent": "Ei lähetetty",
		"user_will_receive_an_email": "Lisätty käyttäjä saa sähköpostiinsa linkin, jonka kautta hän pääsee täyttämään tietonsa.",
		"overview": "Perustiedot",
		"recipient_details": "Vastaanottajatiedot",
		"sent": "Lähetetty",
		"sending": "Lähetetään",
		"information": "Lisätietoja",
		"time_delivered": "Toimitettu",
		"not_delivered": "Ei toimitettu",
		"inactive_contacts_on_receivers": "Inaktiivisia tai estettyjä yhteystietoja",
		"inactive_contacts_on_receivers_guide": "Nämä lisäämäsi vastaanottajat ovat inaktiivisia tai estettyjä, eikä heille lähetetä viestiä:",
		"continue": "Jatka",
		"active": "Aktiivinen",
		"inactive": "Inaktiivinen",
		"blocked": "Estetty",
		"select_substitutions": "Personoi viestiä",
		"expected": "arvio",
		"add_marketing_block": "Lisää markkinointikieltopyynnön linkki",
		"adding_marketing_block": "Markkinointikiellon lisääminen",
		"marketing_block_guide_1": "Voit liittää viesteihin personoidun linkin, jonka kautta viestin vastaanottaja voi lisätä puhelinnumeronsa estolistalle. Estolistalle lisättyihin numeroihin ei jatkossa lähetetä viestejä käyttäjätililtäsi.",
		"marketing_block_guide_2": "Hei, tänään kanta-asiakkaille kaikki tuotteet -20%. Estä markkinointi {{stopLink}}",
		"marketing_block_guide_3": "Yllä olevassa esimerkissä {{stopLink}} termi korvataan vastaanottajakohtaisella URL-osoitteella, jonka kautta henkilö voi estää markkinoinnin. URL-osoite on 27 merkkiä pitkä ja merkkimäärä vähennetään normaalisti käytettävässä olevista merkeistä. URL-osoite on muotoa tavoittaja.fi/xxxxxxxx.",
		"marketing_block_guide_4": "Palvelun käyttö on kaikille asiakkaillemme ilmaista. ",
		"add": "Lisää estolinkki",
		"custom_fields_guide": "lisätietokentät",
		"label": "Nimi",
		"add_custom_field": "Lisää lisätietokenttä",
		"remove_custom_field": "Poista lisätietokenttä",
		"really_remove_custom_field": "Haluatko todella poistaa tämän lisätietokentän?",
		"error_occurred": "Tapahtui virhe",
		"drag_and_drop_file_here": "Paina tästä tai raahaa ja pudota tiedosto tähän",
		"supported_file_types": "Tuetut tiedostotyypit",
		"upload_file": "Lataa tiedosto",
		"choose_columns": "Valitse sarakkeet",
		"confirm_import": "Vahvista tuonti",
		"start_over": "Aloita alusta",
		"previous": "Edellinen",
		"next": "Seuraava",
		"map_to_column": "Yhdistä sarakkeeseen",
		"column_data": "Sarakkeen tiedot",
		"description": "Kuvaus",
		"ignore": "Ohita",
		"select": "Valitse",
		"imports": "Tuonnit",
		"original_file_name": "Alkuperäinen tiedostonimi",
		"error_message": "Virheviesti",
		"remove_contact": "Poista yhteystieto?",
		"really_remove_contact": "Haluatko varamsti poistaa tämän yhteystiedon?",
		"removed": "Poistettu",
		"remove_contacts": "Poista yhteystietoja",
		"really_remove_contacts": "Haluatko varmasti poistaa valitut yhteystiedot?",
		"remove_groups": "Poista ryhmiä",
		"really_remove_groups": "Haluatko varmasti poistaa valitut ryhmät? Ryhmien poistaminen ei poista niissä olevia yhteystietoja.",
		"really_remove_group": "Halautko varmasti poistaa tämän ryhmän?",
		"remove_group": "Poista ryhmä",
		"no_custom_fields_found": "Aloita luomalla uusi lisätietokenttä",
		"no_contacts_found": "Aloita luomalla tai tuomalla uusia yhteystietoja",
		"no_groups_found": "Aloita luomalla uusi ryhmä",
		"no_imports_found": "Ei vielä tuonteja",
		"no_orders_found": "Ei tilauksia",
		"no_messages_found": "Ei lähetettyjä viestejä",
		"no_recipients_found": "Ei vastaanottajia",
		"no_drafts_found": "Ei luonnoksia",
		"no_inbound_numbers_found": "Ei lähetysnumeroita",
		"no_users_found": "Aloita lisäämällä uusia käyttäjiä",
		"no_search_results_with": "Ei hakutuloksia haulla",
		"superadmin_login": "Superadmin login",
		"superadmin": "Superadmin",
		"sms_messages": "SMS Lähetykset",
		"accounts": "Tilit",
		"orders": "Tilaukset",
		"accounts_guide": "Täältä voit kirjautua tileille, lisätä tilien krediittejä, tai poistaa niitä.",
		"waiting_for_approval": "Odottaa hyväksyntää",
		"rejected": "Hylätty",
		"approved": "Hyväksytty",
		"locked": "Lukittu",
		"unknown": "Tuntematon",
		"business_id": "Y-tunnus",
		"remove_accounts": "Poista valitut tilit",
		"really_remove_accounts": "Haluatko varmasti poistaa valitut tilit?",
		"no_accounts_found": "Tilejä ei löydy",
		"login_to_account": "Kirjaudu",
		"logged_in_as": "Hei",
		"accounts_waiting_for_approval": "Seuraavat tilit odottavat hyväksyntää",
		"approve": "Hyväksy",
		"dont_approve": "Hylkää",
		"no_new_registered_accounts_waiting_for_approval": "Ei uusia tilejä odottamassa hyväksyntää.",
		"time_modified": "Muutettu",
		"remove_custom_fields": "Poista lisätietokenttiä",
		"really_remove_custom_fields": "Haluatko varmasti poistaa valitut lisätietokentät?",
		"custom_fields_info_text": "Voit lisätä ja muokata kenttiä Lisätietokentät -välilehdellä",
		"no_custom_fields": "Ei lisätietokenttiä",
		"basic_information": "Perustiedot",
		"edit_contact": "Muokkaa yhteystietoa",
		"time_latest_login": "Viimeisin kirjautumisaika",
		"never_logged_in": "Ei koskaan kirjautunut",
		"used_credits": "Krediitit",
		"unsubscribe": "Estä markkinointi",
		"subscribe": "Salli markkinointi",
		"really_unsubscribe": "Estetäänkö {{account}} markkinointi numeroon {{number}}?",
		"really_subscribe": "Sallitaanko {{account}} markkinointi numeroon {{number}}?",
		"subscribe_success": "Markkinointi sallittu!",
		"unsubscribe_success": "Markkinointi estetty!",
		"filters": "Suodattimet",
		"close": "Sulje",
		"clear_all_filters": "Nollaa kaikki",
		"invalid_sender": "Lähettäjän nimi voi olla joko enintään 11 merkkiä pitkä, jossa saa käyttää vain kirjaimia, numeroita, pisteitä, viivoja (-) ja välilyöntejä, tai puhelinnumero. Tämä on tekstiviestien tekninen rajoitus, ei Tavoittajan asettama rajoitus.",
		"open_order": "Avaa tilaus",
		"download_receipt": "Lataa PDF",
		"generating_pdf": "Luodaan PDF tiedostoa...",
		"after": "Jälkeen",
		"before": "Ennen",
		"select_date": "Valitse aika",
		"no_items": "Ei vaihtoehtoja",
		"marketing_block": "Markkinointikieltolinkki",
		"adding_manual_entries_to_contacts_list": "Uudet numerot",
		"adding_manual_entries_to_contacts_list_guide": "Olet lisännyt manuaalisesti numeroita, joita ei ole tallennettu yhteystietoihin. Nyt voit lisätä niille lisätietoja, jotta ne löytyvät jatkossa esimerkiksi nimen perusteella.",
		"add_details": "Lisää tietoja",
		"done": "Olen lisännyt haluamani tiedot",
		"general_fields": "Peruskentät",
		"go_back_to_previous_page": "Takaisin edelliselle sivulle",
		"no_groups": "Ei ryhmiä",
		"add_to_groups": "Lisää ryhmiin",
		"add_selected_contacts_to_groups": "Tämä toiminto lisää valitut yhteystiedot valittuihin ryhmiin.",
		"choose_groups": "Valitse ryhmät",
		"remove_from_groups": "Poista ryhmistä",
		"remove_selected_contacts_from_groups": "Tämä toiminto poistaa valitut yhteystiedot valituista ryhmistä.",
		"reject_account": "Hylkää tili",
		"really_reject_account": "Haluatko varmasti hylätä tilin? Kirjoita alle hylkäyksen syy.",
		"reject": "Hylkää",
		"approve_account": "Hyväksy tili",
		"really_approve_account": "Hyväksytäänkö tili?",
		"remove_account": "Poista tili",
		"really_remove_account": "Haluatko varmasti poistaa tämän tilin?",
		"account_access": "Tilit",
		"superadmins": "Superadminit",
		"superadmins_guide": "Lisää, muuta ja poista superadmineita.",
		"add_superadmin": "Lisää superadmin",
		"discount_codes": "Alennuskoodit",
		"time_start": "Alennuksen alkamisaika",
		"time_end": "Alennuksen päättymisaika",
		"no_discount_codes_found": "Aloita luomalla alennuskoodi",
		"code": "Koodi",
		"discount_percentage": "Alennusprosentti",
		"usage_limit": "Käyttöraja",
		"add_discount_code": "Lisää alennuskoodi",
		"leave_empty_for_no_limit": "Jätä tämä tyhjäksi jos et halua rajoitusta",
		"monthly_sales": "Myynti (0% ALV)",
		"january": "Tammikuu",
		"february": "Helmikuu",
		"march": "Maaliskuu",
		"april": "Huhtikuu",
		"may": "Toukokuu",
		"june": "Kesäkuu",
		"july": "Heinäkuu",
		"august": "Elokuu",
		"september": "Syyskuu",
		"october": "Lokakuu",
		"november": "Marraskuu",
		"december": "Joulukuu",
		"monthly_credits_spent": "Krediittien käyttö",
		"monthly_messages_sent": "Lähetettyjen viestien määrä",
		"getting_started": "Aloittaminen",
		"here_is_how_to_get_started": "Tervetuloa käyttämään Tavoittajaa. Näin pääset alkuun:",
		"buy_credits_guide_step": "Osta krediittejä",
		"buy_credits_desc": "Tarvitset krediittejä viestien lähettämiseen. Yleinen nyrkkisääntö on, että yksi viesti maksaa yhden krediitin.",
		"add_contacts_guide_step": "Lisää yhteystietoja",
		"add_contacts_desc": "Lisää tai tuo yhteystietoja, joille haluat lähettää viestejä.",
		"send_message_guide_step": "Lähetä viesti",
		"send_message_guide_desc": "Kun olet tehnyt edelliset vaiheet, olet valmis lähettämään ensimmäiset viestisi!",
		"no_sms_message_templates_found": "Aloita luomalla viestipohja",
		"remove_message_templates": "Poista viestipohjia",
		"really_remove_message_templates": "Haluatko varmasti poistaa valitut viestipohjat?",
		"time_latest_message_sent": "Viimeisin viesti lähetetty",
		"time_credits_expire": "Krediitit vanhenevat",
		"id": "ID",
		"edit_superadmin": "Muokaa superadminia",
		"announcements": "Tiedotteet",
		"announcements_guide": "Tekniset tiedotteet sekä ilmoitukset palvelun päivityksistä. ",
		"no_announcements": "Ei tiedotteita",
		"title": "Otsikko",
		"content": "Sisältö",
		"news": "Uutinen",
		"expiring_information": "Ostetut krediitit vanhentuvat vuoden päästä ostotapahtumasta. Krediittejen vanheneminen voidaan estää ostamalla lisää krediittejä.",
		"change_log": "Päivitys",
		"remove_announcement": "Poista ilmoitus",
		"really_remove_announcement": "Haluatko varmasti poistaa tämän ilmoituksen?",
		"remove_announcements": "Poista ilmoituksia",
		"type": "Tyyppi",
		"no_announcements_found": "Aloita luomalla tiedote",
		"add_announcement": "Lisää tiedote",
		"really_remove_announcements": "Haluatko varmasti poistaa valitut ilmoitukset?",
		"payment_status": "Maksun tila",
		"unable_to_fetch_announcements": "Virhe tiedotteiden näyttämisessä. Yritä myöhemmin uudelleen.",
		"save_changes": "Tallenna muutokset",
		"expected_credit_usage": "Krediitit",
		"not_enough_credits": "Ei tarpeeksi krediittejä",
		"add_or_remove_credits": "Muokkaa krediittejä",
		"modify_credits": "Muokkaa krediittejä",
		"add_credits": "Lisää",
		"remove_credits": "Poista",
		"amount": "Määrä",
		"credits_removed": "Krediittejä poistettu",
		"credits_added": "Krediittejä lisätty",
		"monthly_accounts_created": "Uudet tilit",
		"add_message_template": "Lisää viestipohja",
		"add_sms_message_template": "Lisää viestipohja",
		"really_remove_sms_message_template": "Haluatko varmasti poistaa viestipohjan?",
		"remove_sms_message_template": "Poista viestopohja",
		"sms_message_template_added": "Viestipohja luotu",
		"send_message_using_template": "Lähetä viesti viestipohjalla",
		"users_name": "Käyttäjän nimi",
		"users_phone": "Käyttäjän puhelinnumero",
		"users_email": "Käyttäjän sähköpostiosoite",
		"i_just_tried_to_do_something_very_silly": "I just tried to do something very silly!",
		"use_as_template": "Käytä viestipohjana",
		"threshold": "Krediittien määrä",
		"price_per_credit": "Hinta per krediitti",
		"pricing": "Hinnoittelu",
		"more_you_buy_cheaper": "Mitä enemmän ostat, sitä halvempia krediitit ovat.",
		"active_description": "Normaali tila. Tämä yhteystieto voi vastaanottaa tekstiviestejä.",
		"inactive_description": "Tälle yhteystiedolle ei enää lähetetä tekstiviestejä.",
		"blocked_description": "Yhteystieto on kieltänyt markkinoinnin, eikä hänelle lähetetä tekstiviestejä.",
		"time_active_start": "Aktiivinen alkaen",
		"time_active_end": "Aktiivinen asti",
		"active_reservation": "Käytössä tilillä",
		"add_inbound_number": "Lisää lähetysnumero",
		"edit_inbound_number": "Muokkaa lähetysnumeroa",
		"no_active_reservation": "Ei käytössä",
		"is_enabled": "Käytössä",
		"click_to_select_date": "Klikkaa valitaksesi aika",
		"inbound_number_reservations": "Lähetysnumeroiden varaukset",
		"add_inbound_number_reservation": "Lisää varaus",
		"no_inbound_number_reservations_found": "Ei varauksia",
		"inbound_number": "Lähetysnumero",
		"edit_inbound_number_reservation": "Muokkaa varausta",
		"messaging_history": "Viestihistoria",
		"message_from_contact": "Viesti yhteystiedolta",
		"message_to_contact": "Viesti yhteystiedolle",
		"message_name": "Viestin nimi",
		"inbound_messages": "Vastaanotetut viestit",
		"inbound_messages_desc": "Lähetysnumeroihin vastaanotetut viestit näkyvät täällä.",
		"export": "Vie Exceliin",
		"time_received_before": "Vastaanotettu ennen",
		"time_scheduled": "Ajastettu lähtemään",
		"not_scheduled": "Ei ajastettu",
		"number_of_contacts": "Yhteystietoja ryhmässä",
		"select_columns_to_export": "Valitse vietävät sarakkeet",
		"time_unsubscribed": "Markkinointikielto asetettu",
		"created_from": "Mistä luotu",
		"select_all": "Valitse kaikki",
		"api_key_generated": "API-avain on luotu. Kopioi ja tallenna se nyt – et voi tarkastella sitä uudelleen myöhemmin.",
		"copied_to_clipboard": "Kopioitu leikepöydälle",
		"generate_api_key": "Luo API-avain",
		"generate": "Luo",
		"surveys": "Kyselyt",
		"add_survey": "Luo kysely",
		"no_surveys_found": "Aloita luomalla uusi kysely",
		"time_submit_start": "Ajastettu avautumaan",
		"time_submit_end": "Ajastettu sulkeutumaan",
		"surveys_guide": "Voit luoda kyselyitä esimerkiksi palautteen keräämiseen.",
		"add_survey_guide": "Voit luoda kyselyitä esimerkiksi palautteen keräämiseen, ja linkin kyselyihin voit liittää tesktiviestilähetyksiin. Voit muokata kyselyn luonnissa asettamiasi tietoja jälkikäteen kyselyn Asetukset-välilehdellä.",
		"create": "Luo",
		"draft": "Luonnos",
		"submissions": "Vastaukset",
		"edit_fields": "Muokkaa kenttiä",
		"reports": "Raportit",
		"settings": "Asetukset",
		"submissions_guide": "Selaa kyselysi vastauksia alla olevasta listasta. Saat kaikki vastaukset Excel-tiedostoon klikkaamalla Vie Exceliin-painiketta.",
		"no_submissions_found": "Ei vastauksia",
		"edit_fields_guide": "Voit lisätä kyselyysi uusia kenttiä raahaamalla ne lomakkeelle oikeanpuoleisesta sarakkeesta. Lisätyn kentän muokkaus tapahtuu kentän kynäkuvakkeesta. Voit lisätä valmiin kyselyn viestiin Lähetä viesti-sivulla",
		"default_fields": "Vakiokentät",
		"multiple_choices": "Monivalinta",
		"open_answers": "Avoimet vastaukset",
		"ratings": "Arviointiasteikot",
		"survey_structure": "Kyselyn rakenne",
		"choose_one": "Valitse yksi",
		"text": "Tekstikenttä",
		"number": "Numerokenttä",
		"date": "Päivämäärä",
		"smiley": "Hymiö",
		"star": "Tähti",
		"scale": "Arvosana",
		"nps": "NPS",
		"divider": "Jakaja",
		"page_break": "Sivunvaihto",
		"paragraph": "Tekstikappale",
		"textarea": "Monirivinen tekstikenttä",
		"start_by_dragging_elements": "Aloita raahaamalla kenttiä oikeanpuoleisesta sarakkeesta.",
		"no_translation": "Käännös puuttuu",
		"remove_field": "Poista kenttä",
		"really_remove_field": "Haluatko varmasti poistaa tämän kentän? Jos kyselyyn on jo vastattu, kenttään liittyvät vastaukset eivät ole enää saatavilla. Säilyttääksesi vastaukset, piilota kenttä poistamisen sijaan.",
		"reports_guide": "Raportit",
		"settings_guide": "Muokkaa kyselyn yleisiä asetuksia, aktiivisuutta ja ulkoasua.",
		"placeholder": "Placeholder",
		"add_field": "Lisää kenttä",
		"min": "Minimi",
		"max": "Maksimi",
		"drop_here": "Pudota tähän",
		"options": "Vaihtoehdot",
		"add_option": "Lisää vaihtoehto",
		"option_label": "Vaihtoehdon teksti",
		"select_one": "Valitse yksi",
		"finnish": "Suomi",
		"english": "Englanti",
		"swedish": "Ruotsi",
		"en": "Englanti",
		"fi": "Suomi",
		"select_many": "Monivalinta",
		"survey_heading": "Kyselyn otsikko",
		"only_used_internally": "Käytetään vain sisäisenä tunnisteena, ei näytetä kyselyn täyttäjille.",
		"enabled": "Päällä",
		"disabled": "Pois käytöstä",
		"scheduled": "Ajastettu",
		"scheduling_survey": "Kyselyn ajastus",
		"schedule_survey": "Ajasta kysely",
		"unsaved_changes": "Tallentamattomia muutoksia",
		"custom_css": "Custom CSS",
		"custom_css_guide": "Voit muokata kyselyn tyylejä manuaalisesti kirjoittamalla CSS:ää. Dokumentaatiota CSS-kielen käytöstä löydät internetistä.",
		"general_settings": "Yleiset asetukset",
		"text_before_survey": "Teksti kyselyn alkuun",
		"text_after_survey": "Teksti kyselyn loppuun",
		"survey_visuals": "Kyselyn ulkoasu",
		"color_scheme": "Väriteema",
		"logo": "Logo",
		"upload_logo": "Lisää logo",
		"survey_status": "Kyselyn aktiivisuus",
		"survey_not_found": "Kyselyä ei löytynyt",
		"make_sure_link_is_correct": "Varmista että linkki on kopioitu kokonaisuudessaan.",
		"start": "Aloita",
		"submit": "Lähetä",
		"check_answers": "Tarkista vastauksesi ja paina lähetä nappia",
		"open_survey": "Avaa kyselyn esikatselu",
		"answer_sent": "Kiitos vastaamisesta!",
		"content_and_languages": "Sisältö ja kielet",
		"visuals": "Kyselyn ulkoasu",
		"empty_base": "Tyhjä pohja",
		"previously_created_survey": "Aiemmin luotu kysely",
		"select_base_for_survey": "Valitse pohja kyselyllesi",
		"survey_internal_name": "Kyselyn sisäinen nimi",
		"select_survey": "Valitse kysely",
		"status_desc": "Uuden kyselyn tilaksi asetetaan luonnissa aina “Käytössä”. Voit muokata tilaa kyselyn Asetukset-välilehdellä.",
		"heading_and_before_text": "Otsikko ja aloitusteksti",
		"heading_and_before_text_desc": "Otsikko ja teksti kyselyn alkuun esitetään aloitussivulla logon alapuolella. Ilman näitä tietoja kyselyn aloitussivu ei ole käytössä.",
		"after_text": "Lopputeksti",
		"after_text_desc": "Teksti kyselyn loppuun näytetään kyselyn vastaajalle kyselyn täyttämisen jälkeen.",
		"add_language": "Lisää kieli",
		"color_scheme_desc": "Kyselyn väriteema määrittää kyselyn painikkeiden ja monivalintakenttien värin.",
		"logo_desc": "Logo näytetään jokaisen kyselyn sivun yläreunassa.",
		"recommended_size": "Suositeltu koko",
		"recommended_size_desc": "Vaakasuuntainen, 300px leveä",
		"max_file_size": "Maksimitiedostokoko",
		"allowed_extensions": "Sallitut tiedostomuodot",
		"coming_soon": "Tulossa",
		"remove_language": "Poista kieli",
		"save_all_settings": "Tallenna kaikki asetukset",
		"survey_not_fillable": "Kyselyssä ei ole täytettäviä kenttiä.",
		"min_options": "Valitse vähintään {{count}}",
		"max_options": "Voit valita korkeintaan {{count}}",
		"saving": "Tallennetaan...",
		"current_changes_might_not_be_saved": "Uusimmat muutokset eivät ehkä tallentuneet.",
		"remove_survey_submissions": "Poista vastauksia",
		"really_remove_survey_submissions": "Haluatko varmasti poistaa valitut vastaukset?",
		"survey_not_fillable_time": "Kysely ei ole auki",
		"items": "Riviä",
		"invalid_discount_code": "Virheellinen alennuskoodi",
		"remove_discount_code": "Poista alennuskoodi",
		"looking_for_old_tavoittaja": "Etsitkö vanhaa tavoittajaa?",
		"fill_at_least_one_field": "Vastaa ainakin yhteen kenttään",
		"contact_us_to_order": "Ota yhteyttä tilataksesi",
		"is_invoicing_enabled": "Tili voi ostaa krediittejä laskulla",
		"used_times": "Käyttökerrat",
		"link_to_survey": "Linkki kyselyyn",
		"add_survey_link": "Lisää linkki kyselyyn",
		"remove_surveys": "Poista kyselyitä",
		"really_remove_surveys": "Haluatko varmasti poistaa valitut kyselyt?",
		"is_summary_page_shown": "Näytä vastausten yhteenvetosivu kyselyn lopussa",
		"select_at_least": "Valitse vähintään",
		"select_maximum": "Valitse korkeintaan",
		"field_type": "Kentän tyyppi",
		"one_line": "Yksirivinen tekstikenttä",
		"text_area": "Monirivinen tekstikenttä",
		"country": "Maa",
		"procountor_business_partner_identifier": "Procountor business partner identifier",
		"e_invoice_address": "Verkkolaskuosoite",
		"e_invoice_intermediate_id": "Välittäjätunnus",
		"invoice_reference": "Viite / kustannuspaikka",
		"contact": "Yhteystieto",
		"credits_at_the_moment": "Tilin krediitit",
		"submission": "Vastaus",
		"user_guide": "Käyttöopas",
		"basic_details": "Perustiedot",
		"invoicing_details": "Laskutustiedot",
		"remove_survey_submission": "Poista vastaus",
		"really_remove_survey_submission": "Haluatko varmasti poistaa tämän vastauksen?",
		"missing_required_fields": "Täytä kaikki pakolliset kentät myös muiden kielien osalta.",
		"credit_usage_pricing": "Krediittien käyttö lähetyksessä",
		"message_length": "Viestin pituus",
		"price_per_message": "Käytetyt krediitit per viesti",
		"location": "Sijainti",
		"finland": "Suomi",
		"nordics_and_baltic": "Pohjoismaat ja Baltia",
		"usa_and_rest_of_europe": "USA ja muu Eurooppa",
		"credit_usage_desc": "Krediittien käyttö perustuu sisällön pituuteen, joten lähettämäsi viesti voi todellisuudessa koostua useammasta viestistä. Alla olevasta taulukosta näet kuinka pituus vaikuttaa krediittien käyttöön.",
		"above_only_for_finland": "Huom. yllä oleva taulukko koskee kotimaan viestejä. Alta näet kuinka vastaanottajamaa vaikuttaa krediittien käyttöön.",
		"other_countries": "Muut maat",
		"credit_amount": "krediittimäärä",
		"credits_lower_case": "krediittiä",
		"from_ui": "Käyttöliittymästä",
		"from_import": "Tuonneista",
		"api_message_history": "Viestihistoria (API)",
		"sent_messages_guide_api": "Täältä voit tarkastella APIn kautta lähetettyjen viestiesi tietoja. Saat tarkan lähetysraportin esille klikkaamalla viestiä. Viestien vastaanottajien tietoja säilytetään kuluvan ja edellisen kalenterivuoden osalta.",
		"set_billing_email": "Aseta tilille laskutussähköposti 'Tili' valikosta ostaaksesi krediittejä",
		"hidden": "Piilotettu",
		"min_max_guide": "Minimillä ja maksimilla voit määrittää, kuinka monta vaihtoehtoa vastaaja voi valita.",
		"status_message": "Operaattorin viesti",
		"old_email": "Kirjoita tähän sähköpostiosoite, jota käytit vanhassa versiossa. Voit jättää kentän tyhjäksi, jos et tiedä tai muista sitä.",
		"request_credit_transfer": "Pyydän krediittien siirtoa vanhasta versiosta tähän versioon. Siirto tehdään viimeistään yhden työpäivän kuluessa.",
		"nothing_to_export": "Ei dataa vietäväksi",
		"add_contact_to_preview": "Lisää ainakin yksi yhteystieto esikatselua v:arten",
		"pay": "Tilaa",
		"file_too_large": "Tiedosto on liian iso",
		"use_inbound_number": "Käytä lähetysnumeroa",
		"api_documentation": "API dokumentaatio",
		"automatic_credit_purchase": "Automaattinen krediittien osto",
		"add_card": "Lisää maksukortti",
		"add_card_first": "Aloita lisäämällä maksukortti, jolta krediittien ostot veloitetaan",
		"remove_api_key": "Poista API avain",
		"really_remove_api_key": "Haluatko varmasti poistaa API avaimen?",
		"no_api_keys_found": "Aloita luomalla API avain",
		"remove_card": "Poista kortti",
		"automatic_credit_purchase_guide": "Automaattisen krediittien oston avulla voit asettaa tilillesi vähimmäissaldon. Kun saldosi laskee tälle tasolle, järjestelmä ostaa automaattisesti valitsemasi määrän krediittejä.",
		"really_remove_card": "Haluatko varmasti poistaa kortin? Automaattiset krediittiostot lakkaavat toimimasta.",
		"auto_purchase_credit_threshold": "Vähimmäissaldo, jossa krediittejä ostetaan",
		"auto_purchase_credit_amount": "Määrä joka ostetaan",
		"api_keys": "API avaimet",
		"buyer": "Ostaja:",
		"place_order": "Tilaa krediittejä",
		"really_place_order": "Haluatko varmasti tilata krediittejä?",
		"auto_purchase_settings": "Asetukset",
		"always_active": "Vähimmäissaldo, jossa krediittejä ostetaan",
		"always_active_desc": "Kun käytät krediittejä, ja saldosi laskee tämän tason alle, järjestelmä ostaa automaattisesti asettamasi määrän krediittejä. Järjestelmä ostaa enemmän krediittejä, mikäli lähetys vaatii niitä enemmän kuin valitsemasi määrän.",
		"is_automatic_payments_enabled": "Automaattinen krediittien osto käytössä",
		"card_accepted": "Kortti hyväksytty",
		"card_declined": "Kortti hylätty",
		"successful_imports": "Onnistuneita rivejä",
		"skipped_imports": "Ohitettuja rivejä",
		"failed_imports": "Epäonnistuneita rivejä",
		"import_details": "Tuonnin tiedot",
		"import_status_message": "Virheviesti",
		"line_number": "Rivinumero",
		"time_imported": "Tuotu",
		"skipped": "Ohitettu",
		"completed": "Onnistunut",
		"error": "Virhe",
		"we_do_not_store_card_info": "Tavoittaja ei tallenna maksukorttien tietoja.",
		"payment_provider": "Maksupalvelun tarjoaja on Paytrail",
		"send_notification_email": "Haluan sähköpostiini ilmoituksen kun tuonti on valmis",
		"non_valid_email_will_be_skipped": "Mikäli sähköpostiosoite ei ole kelvollinen, rivi tuodaan ilman sitä.",
		"no_import_rows": "Ei rivejä",
		"following_are_invalid": "Virheelliset numerot",
		"bar": "Pylväsdiagrammi",
		"line": "Viivadiagrammi",
		"total_this_year": "Yhteensä tänä vuonna:",
		"month": "Kuukausi",
		"average_per_month": "Keskiarvo",
		"request_invoicing": "Pyydä laskutusoikeutta",
		"interested_in_invoicing": "Voinko maksaa laskulla?",
		"really_request_invoicing": "Jos haluatte maksaa krediittitilauksia laskulla, lähetä meille pyyntö alla olevasta painikkeesta. Olemme teihin yhteydessä mahdollisimman pian.",
		"really_request_invoicing_invoice_fee": "Laskutuspalkkio on 9,90 eur/kpl.",
		"send_invoicing_request": "Pyydä laskutusoikeutta",
		"thank_you_we_will_contact_you_soon": "Kiitos! Otamme sinuun yhteyttä mahdollisimman pian.",
		"order_status": "Tilauksen tila",
		"send_survey_via_message": "Lähetä kysely viestillä",
		"add_new_custom_field": "Lisää uusi lisätietokenttä",
		"all_on_page_selected": "Kaikki tämän sivun rivit on valittu.",
		"all_selected": "Kaikki rivit on valittu.",
		"clear_selection": "Tyhjennä valinnat",
		"invoice_contact_name": "Laskutuksen yhteyshenkilö",
		"invoice_delivery_method": "Laskun toimitustapa",
		"e_invoice": "Verkkolasku",
		"discount_code": "Käytetty alennuskoodi",
		"purchaser_name": "Tilaajan nimi",
		"checkout_payment_status": "Checkout payment status (paytrail)",
		"superadmin_awaiting_invoice_creation": "Odottaa siirtoa Procountoriin",
		"superadmin_awaiting_invoice_acceptance": "Odottaa hyväksyntää Procountorissa",
		"add_individual_recipients": "Lisää yksittäiset vastaanottajat",
		"or_add_new_contacts": "Lisää uusia yhteystietoja",
		"confirm_adding_new_contacts": "Vahvista uusien yhteystietojen lisäys",
		"choose_from_existing": "Tai valitse olemassa olevista yhteystiedoista",
		"add_recipient_groups": "Lisää vastaanottajaryhmät",
		"these_amounts_are_only_expected_amounts": "Yllä olevat määrät ovat arvioita. Näet lopulliset luvut seuraavassa vaiheessa.",
		"special_characters_found": "Huom! Viestissäsi on erikoismerkkejä, jotka voivat saada viestin kuluttamaan enemmän krediittejä:",
		"encoding": "Enkoodaus",
		"message_count": "Lähetetään {{count}} erillisenä viestinä sen pituudesta johtuen",
		"remove_scheduling": "Poista ajastus ja muuta viesti luonnokseksi",
		"remove_scheduling_and_send_now": "Poista ajastus ja lähetä heti",
		"really_send_scheduled_message_now": "Viesti lähetetään heti {{count}} vastaanottajalle. Haluatko jatkaa?",
		"delivery_report_url": "Webhookin lähetysraportin URL",
		"time_received_after": "Vastaanotettu jälkeen",
		"false": "Ei",
		"choose_multiple": "Monivalinta",
		"ui": "Käyttöliittymä",
		"duplicate_account": "Y-tunnuksella on jo tili",
		"duplicate_account_verify": "Y-tunnuksella on jo tili. Haluatko silti hyväksyä myös tämän tilin?",
		"enable": "Aseta automaattinen krediittien osto päälle",
		"choose_payment_method": "Valitse maksutapa",
		"remove_payment_method": "Poista maksutapa",
		"really_remove_payment_method": "Haluatko varmasti poistaa tämän maksutavan?",
		"contact_first_name": "Yhteystiedon etunimi",
		"contact_last_name": "Yhteystiedon sukunimi",
		"contact_full_name": "Yhteystiedon kokonimi",
		"contact_phone": "Yhteystiedon puhelinnumero",
		"contact_company": "Yhteystiedon yritys",
		"webhook_secret": "Webhook secret",
		"sv": "Ruotsi",
		"inbound_number_documentation": "Dokumentaatio",
		"decline_reason": "Hylkäyksen/Lukitsemisen syy",
		"allowed_characters": "Luvitettu nimi tai numero. Voit myös käyttää palvelun luvitettua lähettäjänimeä Tavoittaja.",
		"use_international_format": "Mikäli käytät lähettäjätunnuksena matkapuhelinnumeroa, syötä numero kansainvälisessä muodossa +358501234567. ",
		"you_can_also_use_inbound_number": "Voit myös käyttää 2-suuntaista lähetysnumeroa, joka mahdollistaa viesteihin vastaamisen.",
		"add_recipients_law_guide_1": "Tekstiviestien lähettäminen kuuluu Suomen lainsäädännön alle ja luetaan markkinointiviestinnäksi.",
		"add_recipients_law_guide_2": "Et saa lähettää tekstiviestejä yksityishenkilöille ilman heidän ennakkosuostumustaan.",
		"add_recipients_law_guide_3": "Tarkemmin lainsäädännöstä voit lukea Liikenne- ja viestintäministeriön verkkosivuilta.",
		"remove_imports": "Poista tuonteja historiasta",
		"really_remove_imports": "Haluatko varmasti positaa valitut tuonnit historiasta? Tämä ei poista tuotuja yhteystietoja.",
		"import_rows": "Tuontirivit",
		"mapping_fields": "Sarakkeet",
		"open_contact": "Avaa tiedot",
		"previously_used": "Aiemmin käytetyt",
		"you_previously_used": "Käytä aikaisemmin käytettyä lähettäjää: {{number}}",
		"allowed_traficom_sender_names": "Normaalisti traficomin estämät, mutta tällä tilillä sallitut lähettäjätunnukset",
		"other": "Muut",
		"separate_multiple_names_with_commas": "Erottele nimet pilkulla",
		"change_status": "Vaihda yhteystietojen tilaa",
		"we_recommend_turning_on_automatic_payments": "Suosittelemme, että laitat automaattisen krediittien latauksen päälle. Näin varmistat, ettei viestiliikenne katkea yllättäen.",
		"phone_must_be_10_char": "Puhelinnumeron täytyy olla vähintään 10 numeroa pitkä maakoodin kanssa.",
		"expires_in": "Vanhenee",
		"maybe_dont_use_spaces": "Jos lähetät viestejä ulkomaille, suosittelemme ettei erikoismerkkejä käytetä, koska kaikki ulkomaiset operaattorit eivät niitä tue.",
		"order_rows": "Tilausrivit",
		"info_about_admin_role": "Admin-käyttäjä pystyy lisäämään ja poistamaan käyttäjiä.",
		"placeholder_in_use": "Krediittien määrä on arvio, koska viestiä on personoitu. Näet tarkan määrän seuraavassa vaiheessa.",
		"buy_more_credits": "Osta lisää krediittejä",
		"exporting_rows": "{{count}} riviä valittuna",
		"export_count": "Vie Exceliin ({{count}})",
		"sending_status": "Lähetyksen tila",
		"delivered": "Toimitettu",
		"processing": "Odottaa lähetystä",
		"failed": "Virhe",
		"message_preferences": "Viestintäasetukset",
		"is_informational_messages_allowed": "Haluan vastaanottaa tiliin liittyviä tärkeitä viestejä",
		"is_marketing_messages_allowed": "Haluan vastaanottaa markkinointiviestejä",
		"user": "Käyttäjän tiedot",
		"users_guide_tab": "",
		"this_will_send_emails_to_all_account_users": "Tämän päälle kytkeminen lähettää sähköpostin kaikille tilin käyttäjille, jotka ovat hyväksyneet infoviestit.",
		"is_active": "Käytössä tilillä {{account}}",
		"is_not_active": "Ei käytössä",
		"comment": "Kommentti",
		"add_automatic_payment_method": "Lisää maksutapa",
		"add_payment_method": "Lisää maksutapa",
		"card": "Kortti",
		"add_comment": "Lisää kommentti",
		"external_id": "External ID",
		"tell_us_your_sender_name": "Tavoittajassa lähettäjänimiä voi luvittaa ilmaiseksi",
		"after_46_will_be_unknown": "Luvitukset ovat asiakkaillemme veloituksettomia. Luvitukset käsitellään 10 arkipäivän kuluessa.\nAsiakkaan tulee varmistaa, että luvitetut lähettäjänimet ovat käytössä ja toimivat kaikkien operaattoreiden liittymissä pyydetyllä tavalla.",
		"sender_name_type": "Lähettäjäntunnuksen tyyppi",
		"authorization_level": "Taso",
		"company_name": "Yrityksen nimi",
		"company_website": "Yrityksen verkkosivusto",
		"contact_person_name": "Yhteyshenkilön nimi",
		"purposes": "Käyttötarkoitukset",
		"primary_purpose": "Ensisijainen käyttötarkoitus",
		"secondary_purpose": "Toissijainen käyttötarkoitus",
		"tertiary_purpose": "Kolmas käyttötarkoitus",
		"none": "Ei mitään",
		"trust": "Luottamus (salasanat, tilin vahvistukset ym. luottamukseen liittyvät palvelut)",
		"transactional": "Transaktiollinen (asiakasviestintä – tiedot, ilmoitukset, päivitykset, vahvistukset, hälytykset)",
		"promotional": "Markkinointi (markkinointiin, myyntiin tai mainontaan liittyvät viestit)",
		"alphanumeric": "Alfanumeerinen",
		"registered": "Rekisteröity",
		"authorized": "Luvitettu",
		"processing_prospectum": "Prospectumin käsittelyssä",
		"processing_my_link": "MyLinkin käsittelyssä",
		"reject_reason": "Hylkäyksen syy",
		"create_sender_name": "Luvita lähettäjätunnus",
		"edit_sender_name": "Muokkaa lähettäjätunnusta",
		"created": "Luotu onnistuneesti",
		"updated": "Päivitetty onnistuneesti",
		"sender_names": "Lähettäjätunnukset",
		"sender_names_guide": "Traficomin uuden määräyksen (28 L/2025) myötä kaikkien tekstiviestejä lähettävien toimijoiden tulee luvittaa lähettäjätunnuksensa. Luvittamattomalla lähettäjätunnuksella toimitetut viestit voidaan toimittaa ”Tuntematon”-lähettäjätunnuksella. Luvitus on asiakkaillemme ilmaista, ja se käsitellään 10 arkipäivän kuluessa.",
		"add_sender_name": "Luvita lähettäjätunnus",
		"request_new_sender_name": "Luvita uusi lähettäjänimi",
		"no_sender_names_found": "Lähettäjätunnuksia ei löytynyt",
		"remove_sender_names": "Poista lähettäjätunnukset",
		"really_remove_sender_names": "Haluatko varmasti poistaa kaikki valitut lähettäjätunnukset?",
		"read_info_sender_name": "Lue tiedote",
		"sender_name": "Lähettäjätunnus",
		"sender_name_case_sensitive": "Luvitus on kirjainkokoriippuvainen (esim. \"Tavoittaja\" ja \"TAVOITTAJA\" ovat eri lähettäjätunnuksia). Kirjoita tunnus täsmälleen siinä muodossa, jossa haluat sen näkyvän vastaanottajalle.",
		"processing_s": "Käsittelyssä",
		"sender_name_cannot_be_updated_anymore": "Tätä tunnusta ei voida enää päivittää, sillä se on joko käsittelyssä tai jo käsitelty.",
		"accepted": "Hyväksytty",
		"select_or_type_name": "Valitse listasta klikkaamalla tai kirjoita uusi",
		"select_name": "Valitse lähettäjän nimi listasta",
		"usage_explanation": "Käyttötarkoituksen selitys",
		"usage_explanation_helper": "Kerro mihin lähettäjänimeä käytetään. Erityisen tärkeää, jos valtuutat asiakkaasi lähettäjänimen.",
		"senders_name": "Lähettäjän nimi tai numero",
		"authorize_sender_name": "Luvita lähettäjätunnuksesi",
		"maybe_later": "Luvita myöhemmin",
		"authorize_now": "Luvita nyt (tämä viesti on tallennettu)",
		"remove_sender_name": "Poista lähettäjätunnus",
		"really_remove_sender_name": "Haluatko varmasti poistaa tämän lähettäjätunnuksen?",
		"is_your_sender_name_type_correct": "Onko lähettäjätunnuksen tyyppi oikein?",
		"sender_name_looks_like_phone_number": "Olet määrittänyt tyypin alfanumeeriseksi, mutta nimi sisältää vain numeroita (0–9), +-merkkejä ja välilyöntejä, joten se näyttää puhelinnumerolta.",
		"its_correct": "Se on oikein – ei ole puhelinnumero",
		"no_go_back": "Se on väärin, palaa takaisin",
		"contact_name": "Yhteystiedon nimi",
		"have_read_privacy_policy": "Olen lukenut ja hyväksynyt palvelun ",
		"privacy_policy": "tietosuojaselosteen",
		"privacy_policy_sidebar": "Tietosuojaseloste",
		"resend": "Lähetä uudelleen",
		"resend_message": "Viestin uudelleenlähetys",
		"really_resend_message": "Halautko varmasti lähettää tämän viestin uudelleen?",
		"message_sent": "Viesti lähetetty",
		"close_modal": "Sulje",
		"notice_when_sending_abroad": "Jos lähetät viestejä ulkomaille, huomaathan että lähettäjänimissä on erilaisia rajoitteita eri maissa. Katso suuntaa-antava lista",
		"here": "täältä",
		"contact_not_found": "Yhteystietoa ei löydy",
		"contact_not_found_explanation": "Yhteystietoa ei löydy, sillä se on todennäköisesti poistettu.",
		"no_sender_names": "Ei luvitettuja lähettäjänimiä",
		"account_has_no_sender_names": "Tililläsi ei ole vielä yhtään luvitettua lähettäjänimeä. Luvitus tarvitaan viestien lähettämiseksi.",
		"authorize": "Luvita nyt",
		"password_must_contain_uppercase_lowercase_and_number": "Salasanan tulee sisältää vähintään yksi iso kirjain, yksi pieni kirjain ja yksi numero.",
		"set_invoice_delivery_method": "Aseta laskun toimitustapa tilin asetuksista",
		"invoicing_fee": "{{amount}} €"
	},
	"contacts": {
		"browse_contacts": "Selaa yhteystietoja",
		"browse_contacts_desc": "Selaa kaikkia yhteystietoja",
		"add_contact": "Lisää yhteystieto",
		"import_contacts": "Tuo yhteystiedot",
		"import_contacts_desc": "Tuo uusia tai päivitä olemassaolevia yhteystietoja suoraan tiedostosta",
		"groups_desc": "Ryhmät auttavat sinua järjestelemään yhteystietoja omiin kokonaisuuksiin.",
		"add_group": "Lisää ryhmä",
		"add_to_groups": "Lisää ryhmiin",
		"import_name": "Tuonnin nimi",
		"create_new_group": "Luo uusi ryhmä",
		"create_new_group_desc": "Lisää jokainen tuotu yhteystieto yhteen tai useampaan ryhmään",
		"default_country_code": "Oletusmaatunnus",
		"default_country_code_desc": "Numerot, jotka alkavat 0:lla, korvataan oletuksena tällä maatunnuksella",
		"import_only_new_contacts": "Tuo vain uudet yhteystiedot",
		"import_only_new_contacts_desc": "Jos tämä on päällä, vain uudet yhteystiedot tuodaan eikä olemassa olevia päivitetä",
		"how_is_contact_data_updated": "Miten yhteystietoja päivitetään",
		"contact_data_update_desc": "Valitse, miten olemassa olevien yhteystietojen tiedot päivitetään",
		"overwrite_old_data": "Korvaa vanhat tiedot",
		"add_only_new_properties": "Lisää vain uudet kentät",
		"is_first_row_header": "Onko ensimmäinen rivi otsikko",
		"is_first_row_header_desc": "Jos ensimmäinen arvo sarakkeessa on otsikko (esim. puhelin tai sähköposti), tämä tulisi kytkeä päälle",
		"phone_number_is_needed_to_continue": "Jatkaaksesi sinun täytyy valita vähintään puhelinnumero",
		"import_process_started_in_background": "Tuontiprosessi on käynnissä.",
		"import_status_refreshes_automatically": "Tämä näkymä päivittyy automaattisesti, kun tuonti on valmis.",
		"import_completed": "Tuonti valmis",
		"import_failed": "Tuonti epäonnistui",
		"property_updating_method": "Tietojen päivitysmenetelmä",
		"is_importing_new_only": "Tuodaanko vain uudet",
		"imports_desc": "Selaa ja tutki kaikkia tuontejasi.",
		"show_imports": "Näytä tuonnit",
		"contact_added": "Yhteystieto lisätty",
		"group_added": "Ryhmä lisätty"
	},
	"messages": {
		"time_sent_after": "Lähetetty jälkeen",
		"time_sent_before": "Lähetetty ennen",
		"deliver_details": "Lähetyksen tiedot",
		"sending_in_progress": "Lähetys prosessoi",
		"sending_failed": "Lähetys epäonnistunut",
		"continue_to_choose_recipients": "Jatka vastaanottajien valintaan",
		"credit_cost": "Hinta krediitteinä",
		"per_message": "per viesti",
		"save_draft": "Tallenna luonnos",
		"edit_message_content": "Muokkaa viestin sisältöä",
		"choose_recipients": "Valitse vastaanottajat",
		"confirm_send": "Vahvista lähetys",
		"message_scheduled_successfully": "Viestin ajastus onnistui",
		"message_sending_started_successfully": "Viestin lähetysprosessi on alkanut onnistuneesti",
		"view_more_info_from_details": "Voit tarkastella lisätietoja viestistä ja sen lähetysprosessista menemällä viestin tietoihin",
		"go_back_to_drafts": "Palaa luonnoksiin",
		"go_to_message_details": "Siirry viestin tietoihin",
		"time_is_required": "Aika on pakollinen",
		"select_one_action": "Valitse toiminto",
		"total_recipients": "Vastaanottajia",
		"confirm_schedule": "Vahvista ajastettu lähetys",
		"select_from_existing_contacts": "Hae ja valitse listasta...",
		"name_is_for_internal_use": "Nimi on vain sisäiseen käyttöön, sitä ei näytetä vastaanottajille",
		"you_will_run_out_of_credits": "Ei tarpeeksi krediittejä ajastettuihin viesteihin",
		"scheduled_messages_out_of_credits": "Krediittisi eivät enää riitä ajastamiisi viesteihin - sinulta puuttuu {{missingCredits}} krediittiä."
	}
}
